import { AjaxCampsitePhotosRepository } from '~~/shared/photos/AjaxCampsitePhotosRepository'
import { emptyPhoto } from './emptyPhoto'
import { PitchupPhoto } from './types'
import { NuxtAxiosInstance } from '@nuxtjs/axios'

interface SearchCampsitePhotos {
  general: PitchupPhoto[]
}

export function getCampsitePhotos(
  photos: SearchCampsitePhotos | undefined,
): PitchupPhoto[] {
  if (!photos) {
    return [emptyPhoto]
  }
  return photos.general
}

export class PhotoLoaderService {
  async loadPhotos(
    axios: NuxtAxiosInstance,
    campsiteId: string,
    locale: string,
  ): Promise<PitchupPhoto[]> {
    const repository = new AjaxCampsitePhotosRepository()
    const url = repository.getAjaxUrl(locale, [campsiteId])
    const results = await axios.get(url)
    const photos = repository.mapResults(results.data)
    return getCampsitePhotos(photos[campsiteId]) || []
  }
}
